/**
 * Gmail OAuth for outbound email (Communication → Email tab).
 */
import { getAuthHeaders } from './authHeaders';

const uiConfig = require('../../uiConfig');

const serverUrl = () => uiConfig.serverInfo.serverUrl;

/**
 * @param {string} accountId
 * @param {string} [role] - unused for auth; Super Admin system status uses Bearer token
 */
export async function getGmailOAuthStatus(accountId, role) {
  const headers = await getAuthHeaders();
  const body = accountId
    ? { account_id: accountId }
    : {};
  // role kept for call-site compatibility; server verifies Super Admin via Bearer when account_id omitted
  void role;
  const resp = await fetch(serverUrl() + '/gmailOAuth/status', {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || data.message || 'Unable to load Gmail connection status.');
  }
  return data;
}

/**
 * @param {{ accountId?: string, role?: string, target: 'account'|'system', returnUrl?: string }} opts
 */
export async function getGmailOAuthAuthUrl({ accountId, role, target, returnUrl }) {
  const headers = await getAuthHeaders();
  void role;
  const resp = await fetch(serverUrl() + '/gmailOAuth/authUrl', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      account_id: accountId,
      target,
      return_url: returnUrl || '/Communication?tab=email',
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || data.message || 'Unable to start Gmail authorization.');
  }
  return data;
}

/**
 * @param {{ accountId?: string, role?: string, target: 'account'|'system' }} opts
 */
export async function disconnectGmailOAuth({ accountId, role, target }) {
  const headers = await getAuthHeaders();
  void role;
  const resp = await fetch(serverUrl() + '/gmailOAuth/disconnect', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      account_id: accountId,
      target,
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || data.message || 'Unable to disconnect Gmail.');
  }
  return data;
}
